<div id="balanceReport">
  <div class="container d-flex justify-content-center">
    <div class="card p-3">
      <p class="text-dark">{{fullName}} Account</p>
      <div class="card-bottom pt-3 px-3 mb-2">
        <div class="d-flex flex-row justify-content-between text-align-center">
          <div class="d-flex flex-column"><span>Balance amount</span>
            <p>ZAR <span class="text-white">{{balance}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>